// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const SIMULATION_PARAMETERS = {
  expectedReturns: (
    <Translation
      i18nKey="simulation.expectedReturns"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  expectedVolatility: (
    <Translation
      i18nKey="simulation.expectedVolatility"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  annualDepositWithdrawal: (
    <Translation
      i18nKey="simulation.annualDepositWithdrawal"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  numberOfScenarios: (
    <Translation
      i18nKey="simulation.numberOfScenarios"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export const SIMULATION_PERFORMANCE_SUMMARY = {
  sortinoRatio: (
    <Translation
      i18nKey="simulation.sortinoRatio"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export type SimulationPopupName =
  | keyof typeof SIMULATION_PARAMETERS
  | keyof typeof SIMULATION_PERFORMANCE_SUMMARY;
